module.exports = __webpack_public_path__ + "img/blue-bk2.c9897c4e.jpg";